import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.CarMarket}-enter {
		.${Layouts.CarMarket}-background {
			opacity: 0;
		}

		.${Layouts.CarMarket} {
			opacity: 0;
		}
	}

	&.${Layouts.CarMarket}-enter-active,
		&.${Layouts.CarMarket}-enter-done,
		&.${Layouts.CarMarket}-exit {
		.${Layouts.CarMarket}-background {
			opacity: 1;
		}

		.${Layouts.CarMarket} {
			opacity: 1;
		}
	}

	&.${Layouts.CarMarket}-exit-active {
		.${Layouts.CarMarket}-background {
			opacity: 0;
		}

		.${Layouts.CarMarket} {
			opacity: 0;
		}
	}
`;
